import { toLowerKabobCase } from './string.utils';

/** Modifies the props to ensure that the data-testid and data-auto-testid props are in lower kabob case
 *
 * @param props the props to modify
 */
export const sanitizeTestIdProps = (props: {
  'data-testid'?: string;
  'data-auto-testid'?: string;
}) => {
  sanitizeTestIdProp(props, 'data-auto-testid');
  sanitizeTestIdProp(props, 'data-testid');
};

const sanitizeTestIdProp = (
  props: { 'data-testid'?: string; 'data-auto-testid'?: string },
  propName: 'data-auto-testid' | 'data-testid'
) => {
  if (props[propName] !== undefined) {
    props[propName] = toLowerKabobCase(props[propName]);
  }
};
